import { render } from "./CompanyCard.vue?vue&type=template&id=3cd7e227"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/steve/Desktop/valet/rspremote/web/app/themes/rspremote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__